import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-drivelistfile',
  templateUrl: './drivelistfile.component.html',
  styleUrls: ['./drivelistfile.component.css']
})
export class DrivelistfileComponent implements OnInit {

  responsesamples: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }


  generateResponse() {
    this.responsesamples = true;
  }


  close() {
    this.responsesamples = false;
  }


  sucessData = `
  {
    "data": {
        "kind": "drive#fileList",
        "nextPageToken": "",
        "incompleteSearch": false,
        "files": [
            {
                "kind": "drive#file",
                "id": "1wKmgEGtJ4VGrF91V6d0gEvSumq1uh90Z",
                "name": "Show.MOV",
                "mimeType": "video/quicktime",
                "parents": [
                    "1Wr738WcKtojkAjXzP-GhdWAsGXeLfd9o"
                ],
                "size": 21916983,
                "videoMediaMetadata": {
                    "width": 1920,
                    "height": 1080,
                    "durationMillis": 10009
                },
                "modifiedTime": "2021-12-23T08:30:26Z",
                "shortcutDetails": {
                    "targetId": "",
                    "targetMimeType": "",
                    "targetResourceKey": ""
                }
            },
            {
                "kind": "drive#file",
                "id": "1NfRzrWBmC9Z5xYIOUJgMmTydJOc3xmPZ",
                "name": "Outdoor.MOV",
                "mimeType": "video/quicktime",
                "parents": [
                    "1Wr738WcKtojkAjXzP-GhdWAsGXeLfd9o"
                ],
                "size": 61289641,
                "videoMediaMetadata": {
                    "width": 1920,
                    "height": 1080,
                    "durationMillis": 28561
                },
                "modifiedTime": "2021-08-13T03:45:21Z",
                "shortcutDetails": {
                    "targetId": "",
                    "targetMimeType": "",
                    "targetResourceKey": ""
                }
            }
        ]
    },
    "message": "Files fetched successfully"
}`

  Error5x = `
  {
    "error": {},
    "message": "string"
  }
  `

  Error4x = `
  {
    "error": "unable to generate token",
    "message": "Something went wrong!"
  }`

  Error42x = `
  {
    "error": "request failed",
    "message": "Something went wrong!"
  }`


  Error401x = `
  {
    "error": {},
    "message": "Unauthorized"
  }
  `


}
